import { useEffect, useState } from "react"
import _get from "lodash/get"

export const useBeegolAccessAvailability = (
  customer,
  validateBeegolAccessAvailability
) => {
  const [hasAccess, setHasAccess] = useState(false)

  useEffect(() => {
    if (customer && customer.customerId) {
      checkAccess()
    }
  }, [customer, validateBeegolAccessAvailability])

  const checkAccess = async () => {
    try {
      const response = await validateBeegolAccessAvailability()
      if (!response || !response.payload) {
        setHasAccess(false)
        return
      }

      const circuit = _get(response.payload, "data.circuit", "")

      setHasAccess(circuit && circuit.trim() !== "")
    } catch (error) {
      console.error(error)
      setHasAccess(false)
    }
  }

  return hasAccess
}



// WEBPACK FOOTER //
// ./src/hooks/useBeegolAccessAvailability.js